import { render, staticRenderFns } from "./EmailTemplateAutocomplete.vue?vue&type=template&id=56d380de&"
import script from "./EmailTemplateAutocomplete.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports